import type { IntegrityCheckResult, IntegrityNotification } from '../../types/index';
import { buildIntegrityNotifications, emitIntegrityToasts } from '../utils/integrity-notifications';
import { logIntegrityProcessing } from '../utils/integrity-logging';
import { triggerAutoCleanup as triggerAutoCleanupUtil } from '../utils/integrity-auto-cleanup';

export const createIntegrityActions = (set: any, get: any) => ({
  processIntegrityResults: (institutionId: string, integrityData: any) => {
    const { checks, summary, auto_cleanup_performed } = integrityData || {};
    logIntegrityProcessing(institutionId, summary, auto_cleanup_performed);

    const notifications = get().createIntegrityNotifications(institutionId, checks || []);
    emitIntegrityToasts(notifications, !!auto_cleanup_performed);
  },

  createIntegrityNotifications: (
    institutionId: string,
    checks: IntegrityCheckResult[]
  ): IntegrityNotification[] => {
    const connection = get().getConnection?.(institutionId);
    const institutionName = connection?.connectionData?.institution_name || 'Institution';
    return buildIntegrityNotifications(institutionName, institutionId, checks || []);
  },

  triggerAutoCleanup: async (institutionId: string, checks: IntegrityCheckResult[]) => {
    return triggerAutoCleanupUtil(institutionId, checks);
  },
});
